export default "__VITE_ASSET__CWeSoWhl__"